import createStyles from '@mui/styles/createStyles';
import { theme } from '../../../themes/theme';
export default createStyles({
    chartContainerLarge: {
        height: '200px',
        width: '200px',
        position: 'relative',
        zIndex: '1',
    },
    chartContainer: {
        height: '105px',
        width: '105px',
        position: 'relative',
        margin: '0 auto',
        zIndex: '1',
    },
    chartContainerSmall: {
        height: '88px',
        width: '80px',
        position: 'relative',
        margin: '0 auto',
        zIndex: '1',
    },
    chartText: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
    },
    labels: {
        marginLeft: theme.spacing(2),
        alignSelf: 'center',
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.spacing(2),
        },
    },
    root: {
        display: 'flex',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
        },
    },
    completeText: {
        color: theme.palette.primary.main,
        whiteSpace: 'normal',
    },
    wrapText: {
        whiteSpace: 'normal',
    },
});
